<template>
  <iframe
    class="render-iframe"
    :id="iframeId" 
    :srcdoc="iframeHTML">
  </iframe>
</template>

<script>
export default {
  props: {
    zoneId: { type: String, default: 'z_adrender' },
    containerType: { type: String, default: 'SIMPLE' },
    //position just for docked types
    position: { type: String }
  },
  data () {
    return {
      tag: null
    }
  },
  methods: {
    showAd () {
      let iframe = document.getElementById(this.iframeId)
      let doc = iframe.contentWindow.document;
      let smrtb = {
        dev: true,
        pubId: 123,
        container: {
          type: 'SIMPLE',
          location: 'TOP',
          closeable: false
        },
        medId: "m_903f680ad14717b9d76da789cdafe7",
        zoneId: this.zoneId,
        refreshInterval: 10
      }

      let script = doc.createElement('script');
      script.src = "http://ads.smrtb.com/tag-stubbed.js";
      script.onload = function () {
        new SmartTag(smrtb).setup().start()
      }
      console.log('bbbb', this.tag)
      doc.body.appendChild(script);
    },
    cleanUpAd () {
      let parent = document.getElementById(this.zoneId);
      parent.innerHTML = '';
    },
  },
  mounted () {
    this.showAd()
  },
  computed: {
    iframeId () {
      return this.zoneId + 'frame'
    },
    iframeHTML () {
      return `<html>
        <body>
          <div style="height:800px">
            <p>Gallia est omnis divisa in partes tres, quarum unam incolunt Belgae, aliam Aquitani, tertiam qui ipsorum lingua Celtae, nostra Galli appellantur. Hi omnes lingua, institutis, legibus inter se differunt. Gallos ab Aquitanis Garumna flumen, a Belgis Matrona et Sequana dividit.</p>
            <div style="` +
            (this.containerType === 'STICKY' ? 'height:200px;display:block;' : '') + `">
              ` + this.scriptHTML + `
            </div>
            <p>Horum omnium fortissimi sunt Belgae, propterea quod a cultu atque humanitate provinciae longissime absunt, minimeque ad eos mercatores saepe commeant atque ea quae ad effeminandos animos pertinent important, proximique sunt Germanis, qui trans Rhenum incolunt, quibuscum continenter bellum gerunt.</p>
          </div>
          <style>
            body {
              font-family: 'Gilroy', Helvetica, sans-serif;
              -webkit-font-smoothing: antialiased;
              -moz-osx-font-smoothing: grayscale;
            }
          </style>
        </body>
      </html>`
    },
    scriptHTML () {
      return `<script id="` + this.zoneId + `">
      let smrtb = {
        dev: true,
        pubId: 123,
        container: {
          type: '` + this.containerType + `',
          location: '` + this.position + `'
        },
        medId: "m_903f680ad14717b9d76da789cdafe7",
        zoneId: "` + this.zoneId + `",
        refreshInterval: 0
      }

      let script = document.createElement('script');
      script.src = "http://ads.smrtb.com/tag-stubbed.js";
      script.onload = function () {
        new SmartTag(smrtb).setup().start()
      }
      document.body.appendChild(script);
      </sc` + `ript>`
    }
  },
  watch: {
    containerType () {
      this.showAd()
    },
    position () {
      this.showAd()
    }
  }
}
</script>

<style>
.render-iframe {
  width: 100%;
  height: 100%;
  border: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/AdRender.vue